import { CustomButton } from '@/shared/ui/molecules'
import { Icon } from '@/shared/ui/atoms'

interface FilterDetailButtonProps {
  handleClickOpenReviewFilterModal: (type: "detail") => void
  major: string
  minor: string
  hasReviewAnalysisList: boolean
}

const FilterDetailButton = ({ handleClickOpenReviewFilterModal, major, minor, hasReviewAnalysisList = false }: FilterDetailButtonProps) => {
  if(!hasReviewAnalysisList) return null

  return (
    <CustomButton
      className="relative shrink-0 rounded-full border border-gray-200 px-4 py-2"
      onClick={() => handleClickOpenReviewFilterModal("detail")}
    >
      <Icon src="/icons/filter-icon.svg" width={16} height={16} alt="필터" />
      {(major || minor) && (
        <span className="absolute right-[11px] top-[7px] h-[5px] w-[5px] rounded-full bg-[#FF6B6B]" />
      )}
    </CustomButton>
  )
}

export default FilterDetailButton